import React, { useState } from 'react';
import { Box, Stepper, Step, StepLabel, Button, Container, Typography } from '@mui/material';
import CriteriaToHire from '../layouts/application_form/CriteriaToHire';
import PersonalInfo from '../layouts/application_form/PersonalInfo';
import Education from '../layouts/application_form/Education';
import Employment from '../layouts/application_form/Employment';
import Unemployment from '../layouts/application_form/Unemployment';
import VerifyExperience from '../layouts/application_form/VerifyExperience';
import HOSOnDuty from '../layouts/application_form/HOSOnDuty';
import Accidents from '../layouts/application_form/Accidents';
import TrafficViolations from '../layouts/application_form/TrafficViolations';
import CriminalRecord from '../layouts/application_form/CriminalRecord';
import GeneralInfo from '../layouts/application_form/GeneralInfo';
import FMCSRQuestions from '../layouts/application_form/FMCSRQuestions';
import ReviewApplication from '../layouts/application_form/ReviewApplication';
import ConsentForms from '../layouts/application_form/ConsentForms';
import ConsentFormSignature from '../layouts/application_form/ConsentFormSignature';
import UploadFiles from '../layouts/application_form/UploadFiles';
import DfhLogo from '../utils/dfh.png';
import BoltonCargoLogo from '../utils/bolton-cargo.png';

const sections = [
  { id: 'criteria', label: 'Criteria to Hire' },
  { id: 'personal', label: 'Personal Info' },
  { id: 'education', label: 'Education' },
  { id: 'employment', label: 'Employment' },
  { id: 'unemployment', label: 'Unemployment' },
  // { id: 'verify_experience', label: 'Verify Experience' },
  { id: 'hos', label: 'HOS on Duty' },
  { id: 'accidents', label: 'Accidents (5 Years)' },
  { id: 'violations', label: 'Traffic Violations (3 Years)' },
  { id: 'criminal', label: 'Criminal Record' },
  { id: 'general', label: 'General Info' },
  { id: 'fmcsr', label: 'FMCSR Questions' },
  { id: 'review', label: 'Review & Sign' },
  { id: 'consent', label: 'Consent Forms' },
  { id: 'final_signature', label: 'Final Signature' },
  { id: 'upload_files', label: 'Upload Files' }
];

export default function ApplicationPage({ logo = DfhLogo, companyName = "Dynamic Freight Haulers" }) {
  const [activeStep, setActiveStep] = useState(0);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const [unemploymentHistory, setUnemploymentHistory] = useState([]);
  const [finished, setFinished] = useState(false);

  const handleNext = () => {
    if (activeStep === sections.length - 1) {
      setFinished(true);
    } else {
      setActiveStep((prev) => Math.min(prev + 1, sections.length - 1));
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const handleEmploymentSubmit = (data) => {
    setEmploymentHistory(data);
    handleNext();
  };

  const handleUnemploymentSubmit = (data) => {
    setUnemploymentHistory(data);
    handleNext();
  };

  const renderSection = () => {
    switch (sections[activeStep].id) {
      case 'criteria':
        return <CriteriaToHire onNext={handleNext} logo={logo} />;
      case 'personal':
        return <PersonalInfo onNext={handleNext} />;
      case 'education':
        return <Education onNext={handleNext} />;
      case 'employment':
        return <Employment onNext={handleEmploymentSubmit} />;
      case 'unemployment':
        return <Unemployment onNext={handleUnemploymentSubmit} />;
      case 'hos':
        return <HOSOnDuty onNext={handleNext} />;
      case 'accidents':
        return <Accidents onNext={handleNext} />;
      case 'violations':
        return <TrafficViolations onNext={handleNext} />;
      case 'criminal':
        return <CriminalRecord onNext={handleNext} />;
      case 'general':
        return <GeneralInfo onNext={handleNext} />;
      case 'fmcsr':
        return <FMCSRQuestions onNext={handleNext} />;
      case 'review':
        return <ReviewApplication onNext={handleNext} />;
      case 'consent':
        return <ConsentForms onNext={handleNext} />;
      case 'final_signature':
        return <ConsentFormSignature onNext={handleNext} />;
      case 'upload_files':
        return <UploadFiles onNext={handleNext} />;

      // case 'verify_experience':
      //   return (
      //     <VerifyExperience
      //       employmentHistory={employmentHistory}
      //       unemploymentHistory={unemploymentHistory}
      //       onNext={handleNext}
      //       onBack={handleBack}
      //     />
      //   );
      default:
        return <div>{sections[activeStep].label}</div>;
    }
  };

  const isBackDisabled = () => {
    return activeStep === 0 || sections[activeStep - 1].id === 'review';
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ width: '100%', mt: 4 }}>
        {!finished && (
          <>
            <Stepper activeStep={activeStep} alternativeLabel>
              {sections.map((section) => (
                <Step key={section.id}>
                  <StepLabel>{section.label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box sx={{ mt: 4, mb: 2 }}>
              {renderSection()}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2, pb: 10 }}>
              <Button
                color="inherit"
                disabled={isBackDisabled()}
                onClick={handleBack}
              >
                Back
              </Button>
            </Box>
          </>
        )}
        {finished && (
          <Box sx={{ textAlign: 'center', mt: 10, mb: 10 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
              <Box
                component="img"
                src={logo}
                alt={companyName}
                sx={{ height: logo && logo.includes('bolton-cargo') ? 200 : 80, mb: 1 }}
              />
            </Box>
            <Typography variant="h5" fontWeight="bold">
              Congratulations on completing application for {companyName}.<br />
              We will be reaching out shortly if there's a good match.
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
}
